/* CSS */
import "@js/parts/css";

/* JS */
import "@js/parts/lazyloading";
import "@js/parts/fadeIn";
import * as mapInit from "@js/parts/mapInit";
import BiographyMapAnimation from "@js/parts/biographyMapAnimation";
import PersonMapController from "@js/parts/personMapController";
import UIkit from "uikit";

import "flowbite";
import "@js/parts/navigation";

/**
 * Alpine JS
 * Best to put it last so that all other potential JS is available
 * when components start getting initialized.
 */
import Alpine from "alpinejs";
window.Alpine = Alpine;
Alpine.start();

// Map globals
window.mapState = {
  map: null,
  linksWithCoordinates: [],
  featureCollection: null,
  highlightedMarkerIndex: null,
  activeMarkerIndex: null,
  hoveredMarkerIndex: null,
  lastActiveMarkerIndex: null,
  pendingActiveIndex: null,
  layersInitialized: false,
  bounds: null,
  idleResetTimer: null,
  idleResetEnabled: true,
  projection: "mercator",
  resetToAllMarkers: mapInit.resetToAllMarkers,
  initializeMap: mapInit.initializeMap,
  setupMarkers: mapInit.setupMarkers,
  setupScrollListener: mapInit.setupScrollListener,
  setupLinkMouseEvents: mapInit.setupLinkMouseEvents,
  setActiveLink: mapInit.setActiveLink
};

// Biography map animation
window.BiographyMapAnimation = BiographyMapAnimation;
window.PersonMapController = PersonMapController;
